import { Mouse, MouseFill, CheckCircleFill } from "react-bootstrap-icons";
import { EanQuantityBundle } from "../../../components/EanQuantityBundle";
import { QuantityBadge } from "../../../components/QuantityBadge";
import { ShelfGrid } from "../../../components/ShelfGrid";
import { LocationData } from "../../../types/data";
import { Locations } from "../../../ui";
import styles from "./ResultsTable.module.css";
import { HelpText } from "../../../components/HelpText";
import { EANView } from "../../../components/EANView";

interface Props {
  data: LocationData[];
  filterShelf: string;
  copiedLocation: string | null;
  activeShelfIcon: string | null;
  onShelfClick: (location: string) => void;
  onCopy: (location: string, eans: string) => void;
  isLoading?: boolean;
  singleAisleEans: Set<string>;
}

export const ResultsTable = ({
  data,
  filterShelf,
  copiedLocation,
  activeShelfIcon,
  onShelfClick,
  onCopy,
  isLoading = false,
  singleAisleEans
}: Props) => {
  const skeletonRows = Array.from({ length: 3 }, (_, i) => i);

  return (
    <>
      {!isLoading && (
        <HelpText>
          W lewej kolumnie są wyświetlane lokalizację regałów z wizualizacją miejsca w nich, a w prawej zawartość danego
          miejsca. Kliknięcie w lewą kolumnę ustawia filtrowanie wyników do wybranego regału, a w prawą zapisuje EAN-y w
          schowku.
        </HelpText>
      )}
      <Locations>
        <table className={styles.table}>
          <tbody>
            {isLoading
              ? skeletonRows.map((key) => (
                  <tr key={key} className={styles.skeletonRow}>
                    <td>
                      <div className={styles.skeletonLine} style={{ width: "80px" }}></div>
                    </td>
                    {/* <td>
                      <div className={styles.skeletonGrid}></div>
                    </td> */}
                    <td>
                      <div className={styles.skeletonLine} style={{ width: "150px" }}></div>
                    </td>
                  </tr>
                ))
              : data.map(
                  (e) =>
                    e.location.startsWith(filterShelf) && (
                      <tr key={e.location}>
                        <td onClick={() => onShelfClick(e.location)}>
                          <div className={styles.copyWrapper}>
                            {e.location.substring(0, 7)}{" "}
                            {/* {activeShelfIcon === e.location ? (
                              <MouseFill style={{ color: "lightslategray" }} />
                            ) : (
                              <Mouse style={{ color: "lightslategray" }} />
                            )} */}
                          </div>
                          <ShelfGrid location={e.location} />
                        </td>
                        {/* <td>
                          <ShelfGrid location={e.location} />
                        </td> */}
                        <td onClick={() => onCopy(e.location, e.results.map((r) => r.ean).join(","))}>
                          <div className={styles.copyWrapper}>
                            {e.results.map((item) => (
                              <EanQuantityBundle
                                key={item.ean}
                                disableAnimation={true}
                                singleAisle={singleAisleEans.has(item.ean)}
                              >
                                <EANView ean={item.ean} />
                                <QuantityBadge status={item.quantity === 0 ? "minus" : "special"}>
                                  {item.quantity}
                                </QuantityBadge>
                              </EanQuantityBundle>
                            ))}
                            {/* {copiedLocation === e.location ? (
                              <CheckCircleFill size={16} style={{ color: "lightslategray" }} />
                            ) : (
                              <Mouse size={16} style={{ color: "lightslategray" }} />
                            )} */}
                          </div>
                        </td>
                      </tr>
                    )
                )}
          </tbody>
        </table>
      </Locations>
    </>
  );
};
